

export default (function (_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: right - left,
    height: bottom - top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/esm/state/get-area.js
// module id = 179
// module chunks = 0